import { makeAutoObservable } from 'mobx';
import { groupByFunction } from '../websocketStore/utils/rxjs/groupByFunction';

export class AlertsNotificationStore {
  root;
  notificationsSubject;
  notificationsByWatchlist = {};

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.initializeStream();
  }

  initializeStream = () => {
    this.notificationsSubject = groupByFunction(
      'messageType',
      'notifications',
      this.root.websocketSubject
    ).subscribe((msg) => this.handleAlertNotificationStream(msg));

    groupByFunction(
      'messageType',
      'removeNotifications',
      this.root.websocketSubject
    ).subscribe((msg) => this.handleRemoveNotificationMsg(msg));
  };

  handleAlertNotificationStream = (msg) => {
    if (
      msg.notificationId &&
      msg.notificationDetails &&
      msg.notificationDetails?.notificationType
    ) {
      if (msg.notificationDetails?.TRADE_PLAN) {
        if (msg.notificationDetails?.TRADE_PLAN?.type === 'ALERT') {
          const id = msg.notificationId;
          const watchlistName =
            msg.notificationDetails.TRADE_PLAN.watchlistName;
          if (this.notificationsByWatchlist[watchlistName]) {
            this.notificationsByWatchlist[watchlistName][id] = msg;
          } else {
            this.notificationsByWatchlist[watchlistName] = {
              [id]: msg,
            };
          }
        }
      }
    }
  };
  handleRemoveNotificationMsg = (msg) => {
    for (const watchlist in this.notificationsByWatchlist) {
      for (const notificationId in this.notificationsByWatchlist[watchlist]) {
        if (notificationId === msg.id) {
          delete this.notificationsByWatchlist[watchlist][msg.id];
        }
      }
    }
  };
}
